import mandatorUtils from "./utils";

export default mandatorUtils;
